import { RouteConfig } from "vue-router";

export type TRouterLink = {
  path: string;
  label: string;
  icon?: string;
  newIcon?: string;
  isChild?: boolean;
  childLabel?: string;
  childLabels?: string[];
  hide?: boolean;
  basePath: string;
};

const createRouterLink = (route: RouteConfig, routeBase?: string): TRouterLink | null => {
  const { path, meta } = route;

  if (meta && meta.title && (meta.icon || meta.newIcon)) {
    return {
      path: (routeBase ? "/" + routeBase : "") + (path ? "/" + path : ""),
      label: meta.title,
      icon: meta.icon,
      newIcon: meta.newIcon,
      isChild: !!meta.isChild,
      childLabel: meta.childLabel ?? "",
      childLabels: meta.childLabels ?? [],
      hide: meta.hide ?? false,
      basePath: path,
    };
  }

  return null;
};

export const createRouterLinks = (route: RouteConfig): TRouterLink[] => {
  const routerLinks = (route.children ?? [])
    .map((child) => createRouterLink(child, route.path))
    .filter((route): route is TRouterLink => !!route);
  return routerLinks;
};
